:host {
  display: flex;
}
:host ul {
  margin: 0;
  padding-left: 0;
  width: 100%;
}
:host .nested-tree {
  width: 100%;
}

:host(.main-tree) {
  overflow: hidden;
}

.main-tree-container {
  position: relative;
  width: 100%;
}